import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/incidents/resolved')({
  beforeLoad: () => {
    throw redirect({ to: '/incidents', search: { view: 'list', status: 'Resolved' } })
  },
})
